import moment from "moment"
import Send from "../communication"
import { sort } from "fast-sort"
import {
  buildFavoritedPayload,
  sendFirebaseMessage,
} from "./utils/testimonials.utils";

export const handleSaveTestimonials = async (
  data,
  resetPinnedMessages,
  customToast,
  setReload = () => { },
  setFavoritedMessages,
  setIsLoadingTestimonial
) => {
  const {
    farmerDetails,
    pinnedMessages,
    dataToUpdate,
    loggedUser,
  } = data;

  console.log("DSD", data)

  const formId = "21944091-4b0d-4539-8ed8-4aca65792ecd";
  const formattedData = {
    ...dataToUpdate,
    dateToAdd: moment.utc(Date.now()).format("YYYY-MM-DD"),
  };

  const respondedAnswers = {
    "58853300-abc5-4f97-a665-d1fb4c0896ee": { value: "Não", label: "Não" },
  };

  try {
    const message = pinnedMessages[0];
    setIsLoadingTestimonial(message?.id)

    const response = await Send.post(`/events-sector/assistance-context`, {
      title: "Registro de Depoimento",
      type: "Registro de Depoimento",
      answers: respondedAnswers,
      assistanceType: "save",
      farmerDetails,
      pinnedMessages,
      formId,
      testimonials: true,
      dataToUpdate: formattedData,
    });

    const eventSectorId = response?.data?.eventSectorId;
    if (response?.status !== "success" || !eventSectorId) {
      throw new Error("Erro ao salvar no backend");
    }

    const favorited = buildFavoritedPayload({
      baseFavorited: {},
      status: "added",
      loggedUser,
      projectId: farmerDetails?.projectId,
      eventSectorId,
    });

    const firebaseResult = await sendFirebaseMessage({
      messageData: message,
      favorited,
      loggedUser,
    });

    if (!firebaseResult) {
      await Send.delete(`/events-sector/testimonial/${eventSectorId}`);
      throw new Error("Erro ao salvar no Firebase. Ação foi revertida.");
    }

    setFavoritedMessages((prev) => [...prev, { ...message, eventSectorId }]);
    customToast("Destaque salvo com sucesso", "success");
    //resetPinnedMessages();

  } catch (error) {
    console.error("Erro ao salvar depoimento:", error);
    customToast(error?.message || "Erro ao salvar depoimento", "error");
    //resetPinnedMessages();
  }
  finally {
    setIsLoadingTestimonial(null)
  }
};

export const handleRemoveSavedTestimonials = async (
  data,
  resetPinnedMessages,
  customToast,
  setReload = () => { },
  setFavoritedMessages,
  favoritedMessages,
  setIsLoadingTestimonial,
) => {
  const { farmerDetails, message, loggedUser } = data;


  try {
    const testimonialMessageId = message?.id;
    const testimonialFavorited = message?.favorited;

    setIsLoadingTestimonial(testimonialMessageId)

    const matchedFavorite = favoritedMessages.find(
      (item) => item.id === testimonialMessageId
    );

    const eventSectorId =
      testimonialFavorited?.eventSectorId || matchedFavorite?.eventSectorId;

    if (!eventSectorId) {
      throw new Error("Id do destaque não encontrado");
    }

    const favorited = buildFavoritedPayload({
      baseFavorited: testimonialFavorited,
      status: "removed",
      loggedUser,
      projectId: farmerDetails?.projectId || null,
      eventSectorId,
    });

    const firebaseResult = await sendFirebaseMessage({
      messageData: message,
      favorited,
      loggedUser,
      isAudioToSender: true,
    });

    if (!firebaseResult) {
      throw new Error("Erro ao excluir depoimento do chat.");
    }

    const response = await Send.delete(`/events-sector/testimonial/${eventSectorId}`);

    if (response?.status === "success") {
      setFavoritedMessages((prev) =>
        prev.filter((msg) => msg.id !== testimonialMessageId)
      );
      setIsLoadingTestimonial(null)
      resetPinnedMessages();
      customToast("Sucesso ao excluir depoimento", "success");
    } else {
      const revertFavorited = buildFavoritedPayload({
        baseFavorited: testimonialFavorited,
        status: "added",
        loggedUser,
        projectId: farmerDetails?.projectId || null,
        eventSectorId,
      });

      await sendFirebaseMessage({
        messageData: message,
        favorited: revertFavorited,
        loggedUser,
        isAudioToSender: true,
      });

      throw new Error("Erro ao excluir depoimento. A ação foi revertida.");
    }

  } catch (error) {
    console.error("Erro ao excluir depoimento:", error);
    customToast(error?.message || "Erro ao excluir depoimento", "error");
    setIsLoadingTestimonial(null)
  }
};

export const getTestimonials = async (scopeId, scopeType, isFavorite = false, user = "", currentUser, usersProject, pageParam = 1, limit = 10) => {

  const response = !isFavorite ? await Send.get(
    `/events-sector/assistance-context/${scopeId}`,
    `scopeType=${scopeType}&page=${pageParam}&limit=${limit}&getFileType=true`,
  ) : []

  const { data: dataAux, total, totalPages, hasMore, nextPage } = response

  let concat = []
  if (dataAux && dataAux.length > 0) {
    concat = dataAux
  }

  return {
    data: sort(concat?.filter(item => item?.image !== null && item?.image !== "Ø" && item)).desc((u) => u.createdAt),
    total,
    totalPages,
    hasMore,
    nextPage
  }
};

export const getTestimonialsFavorited = async (scopeId, scopeType, isFavorite = false, user = "", currentUser, usersProject, pageParam = 1, limit = 10) => {
  const isTecUser = currentUser === 'USER_TEC';

  const data = await Send.get(`/events-sector/testimonials/${scopeId}`, `${isTecUser ? `tecId='${user.id}'&scopeType=${scopeType}` : `scopeType=${scopeType}`}`);

  return data
};


export const updateFavoriteTestimonial = async (testimonial) => {
  const { data } = await Send.put(`/events-sector/testimonial/${testimonial?.eventId}/favorite`, testimonial);
  return data;
};

export const testimonialsFilter = (data, favoritedTestimonials) => {
  const seenEventIds = new Set()

  const testimonialsData = favoritedTestimonials
    ? data?.filter((item) => {
      if (item.value?.toLowerCase() !== "sim") {
        return false
      }
      if (item.eventId && seenEventIds.has(item.eventId)) {
        return false
      }
      if (item.eventId) {
        seenEventIds.add(item.eventId)
      }
      return true
    })
    : data?.filter((item) => {
      if (item.eventId && seenEventIds.has(item.eventId)) {
        return false
      }
      if (item.eventId) {
        seenEventIds.add(item.eventId)
      }
      return true
    })

  return testimonialsData || []
}
